<template>
  <div id="app">
    <div class="load-overlay" v-bind:class="{loaded: load}"></div>
    <sidebar v-on:menu="togglePanel()"></sidebar>
    <header class="header--main">
        <h2><b>Free Photos</b> by <a href="https://thefrontend.uk" target="_blank">Alex Shepherd</a></h2>
        <img src="./assets/cc.svg" alt="Creative Commons" width="32px" height="32px">
        <img src="./assets/by.svg" alt="Creative Commons" width="32px" height="32px">
    </header>
    <images v-bind:class="{menuOpen: menu}"></images>
  </div>
</template>

<script>
import Sidebar from './components/Sidebar.vue'
import Images from './components/Images.vue'

export default {
  name: 'app',
  components: {
    Sidebar,
    Images
  },
  data () {
    return {
      menu: false,
      load: false

    }
  },
  created: function () {
    this.load = true
  },
  methods: {
    togglePanel: function () {
      this.menu = !this.menu
    }
  }
}
</script>

<style lang="scss">

@import 'sass/main.scss';


html, body {
  font-size: 16px;
  font-family: 'Oxygen', Helvetica, Arial, sans-serif;
}

#app {
  font-family: 'Oxygen', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $gray;
  width:100%;
  overflow-x: hidden;
  height:100%;
  display:flex;
}

.header--main {
    background-color: white;
    position:absolute;
    right:1.875em; /* 30/16 */
    top:1.875em; /* 30/16 */

    @media screen and (max-width: 756px) {
      font-size: 0.8em;
    }

    * {
        mix-blend-mode: difference;
        color: white;
    }

    a {
        text-decoration: none;
        color: darken(white,30%);

        &:hover, &:active {
            color: #04a6b3;;
        }
    }



    h2 {
        z-index:99999;
        font-weight:400;
        margin:0;
        font-size: 1.25em; /* 20/16 */
        display:inline-block;
        vertical-align: middle;
        margin-right:0.5em; /* 10/20 */
        position:relative;
    }

    img {
        z-index:99999;
        vertical-align: middle;
        margin: 0 0.125em; /* 2/16 */
        position:relative;
        width: 2em; /* 32/16 */
        height: 2em;
    }
}

.images {
  transition: .5s;
  transition-timing-function: cubic-bezier(.74,.01,.78,1);
  position: relative;
  left:0;
}

.menuOpen {
  left: 31.25em;
}


</style>



// WEBPACK FOOTER //
// App.vue?bdb7ba14